import { ReactElement } from 'react';

import { EmptyStatePlaceholder, FilterPanel, Link, LinkSize } from '@dreryk/react-components';

import { GroupSessionsCreateModalOpener } from '../create/GroupSessionsCreateModal.opener';
import { translationKeys } from '../translations';

export const GroupSessionsEmptyStatePlaceholder = (): ReactElement => {
   const filtersParamsApplied = FilterPanel.useDetectParamsApplied();

   if (filtersParamsApplied) {
      return <EmptyStatePlaceholder testId={'noGroupSessionsEntries'} heading={translationKeys.noMatchingResults} />;
   }

   return (
      <EmptyStatePlaceholder
         testId={'noGroupSessions'}
         heading={translationKeys.noGroupSessionsCreated}
         subheading={translationKeys.noGroupSessionsAddedYet}
      >
         <GroupSessionsCreateModalOpener>
            {({ openModal }) => (
               <Link
                  testId={'createTherapeuticGroup'}
                  label={translationKeys.createTherapeuticGroup}
                  onClick={openModal}
                  size={LinkSize.NORMAL}
               />
            )}
         </GroupSessionsCreateModalOpener>
      </EmptyStatePlaceholder>
   );
};
